export default __webpack_public_path__ + "img/discover-3225daa8f79591a4ee95a6de892f4f00.png";